

















import { FitButton, FitVerifyPwdPage } from '@tencent/wphk-ui';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {
    FitButton,
    FitVerifyPwdPage,
  },
})
export default class PwdConfirm extends Vue {
  @Prop() public title!: string;
  @Prop() public subTitle!: string;
  @Prop() public confirmText!: string;
  @Prop({ default: () => [] }) public pin!: string[];
  @Prop({ default: 6 }) public pwdLength!: number;
}
